export const NTH_PROJECT_CREATE = 'nthProjectCreate';
